import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRealtime } from '../../contexts/RealtimeContext';
import { isAdmin } from '../../utils/rbac';
import { handleError, ERROR_TYPES } from '../../utils/errorHandler';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, isInitialized, userProfile } = useRealtime();
  const location = useLocation();

  // Show loading while checking authentication
  if (!isInitialized || (currentUser && !userProfile)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If no user is authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If admin is required, check if user is admin using proper RBAC
  if (requireAdmin) {
    try {
      const userIsAdmin = isAdmin(userProfile, currentUser);
      if (!userIsAdmin) {
        // Log unauthorized access attempt
        handleError(
          new Error('Unauthorized admin access attempt'),
          {
            context: {
              userId: currentUser.uid,
              email: currentUser.email,
              path: location.pathname
            },
            logError: true,
            showToUser: false
          }
        );
        return <Navigate to="/dashboard" replace />;
      }
    } catch (error) {
      // If RBAC check fails, deny access
      handleError(error, {
        context: { userId: currentUser.uid, path: location.pathname },
        logError: true
      });
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
